// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'

const colorMap = {
  'Active': 'green',
  'Inactive': 'yellow',
  'Invalid': 'red',
}

// when exporting, we just want to return the string value
export const exportValue = ({ columnKey, rowData }) => rowData[columnKey]

// but when displaying in the UI, we want to display an icon
// whose color reflects the status of the data
const statusClasses = props => `database-search-status-icon bg-${colorMap[exportValue(props)]}`
const wrapperClasses = 'display-flex justify-content-between align-items-center'

const FormatStatus = props => (
  <div className={wrapperClasses}>
    <p
      className={statusClasses(props)}
      title={exportValue(props)} />
  </div>
)

FormatStatus.propTypes = {
  columnKey: string.isRequired,
  rowData: object.isRequired,
}

export default FormatStatus
